"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductCategoryCardPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var ProductCategoryCardPropTypes = {
  PropTypes: {
    data: _propTypes.default.shape({
      url: _propTypes.default.string,
      cta: _propTypes.default.string,
      primaryLabel: _propTypes.default.string,
      image: _propTypes.default.string,
      lowResolutionImageUrl: _propTypes.default.string,
      secondaryLabel: _propTypes.default.string,
      attractText: _propTypes.default.string,
      title: _propTypes.default.string,
      subtitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]),
      star: _propTypes.default.string,
      location: _propTypes.default.string,
      priceDisclaimer: _propTypes.default.string,
      discount: _propTypes.default.string,
      originalprice: _propTypes.default.string,
      price: _propTypes.default.string,
      priceClarification: _propTypes.default.string,
      rating: _propTypes.default.string,
      secondaryImage: _propTypes.default.string,
      labelColor: _propTypes.default.string,
      mobileAppImageURL: _propTypes.default.string,
      newTab: _propTypes.default.string,
      position: _propTypes.default.string,
      productID: _propTypes.default.string,
      hidden: _propTypes.default.string,
      productType: _propTypes.default.string,
      currencyCode: _propTypes.default.string,
      accessibilityText: _propTypes.default.string,
      cnDisclaimerLine1: _propTypes.default.string,
      cnDisclaimerLine2: _propTypes.default.string,
      cndisclaimerLine1: _propTypes.default.string,
      cndisclaimerLine2: _propTypes.default.string,
      chinaURL: _propTypes.default.string,
      companyURL: _propTypes.default.string,
      companyName: _propTypes.default.string,
      countDown: _propTypes.default.string,
      timer: _propTypes.default.string,
      timerEndDateTime: _propTypes.default.string,
      timerLabelEndDays: _propTypes.default.string,
      timerLabelEndHours: _propTypes.default.string,
      timerLabelStartDays: _propTypes.default.string,
      timerLabelStartHours: _propTypes.default.string,
      timerStartDateTime: _propTypes.default.string,
      timerTimeZone: _propTypes.default.string,
      formattedPrice: _propTypes.default.string,
      formattedOriginalPrice: _propTypes.default.string,
      colorButton: _propTypes.default.oneOf(_constant.ARR_COLORS),
      hoverColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      backgroundColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      hoverBackgroundColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
      widthButton: _propTypes.default.string,
      customPropertiesButton: _propTypes.default.object,
      promotionTnC: _propTypes.default.string,
      promotionCouponCode: _propTypes.default.string,
      couponBoxLabel: _propTypes.default.string,
      couponBoxCtaText: _propTypes.default.string,
      subtitleExpandCtaText: _propTypes.default.string
    }),
    enableProgressiveImageLoading: _propTypes.default.bool,
    lazyLoadImage: _propTypes.default.bool,
    index: _propTypes.default.string,
    fireGtm: _propTypes.default.func,
    gtmEventData: _propTypes.default.string,
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    width: _propTypes.default.string,
    hoverEffect: _propTypes.default.bool,
    focusEffect: _propTypes.default.bool,
    handleClick: _propTypes.default.func,
    imageHoverAnimation: _propTypes.default.bool,
    chinaDisclaimerListener: _propTypes.default.func,
    isCnDomain: _propTypes.default.bool,
    isMobile: _propTypes.default.bool,
    idConfig: _propTypes.default.exact({
      widgetName: _propTypes.default.string,
      parentName: _propTypes.default.string
    })
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    imageHoverAnimation: true,
    hoverEffect: false,
    isCnDomain: false,
    isMobile: false
  }
};
exports.ProductCategoryCardPropTypes = ProductCategoryCardPropTypes;